var ExternalInterface = (function () {
    function ExternalInterface() {
    }
    ExternalInterface.addCallback = function (methodName, instance, method) {
        console.log("addCallback not implemented yet in flash/ExternalInterface");
        return false;
    };
    ExternalInterface.call = function (methodName, parameter1) {
        console.log("methodName not implemented yet in flash/ExternalInterface");
        return null;
    };
    return ExternalInterface;
}());
export { ExternalInterface };
